window.initBatchGeoShortcuts = function () {
  var strings = BatchGeoStrings.getStringsForComponent(
    "BatchGeoKeyboardShortcuts",
  );
  /**
   * _selectionDirectionHandler
   * Uses the BatchGeoTable and RowSelect API's to navigate the data table selections.
   *
   * @param  {object} `options` An options hash.
   *    - direction: the direction the selection is moving/expanding. 'up' or 'down'.
   *    - addRows: differentiates selection moving vs expanding. Set true to add
   *               rows to selection.
   */
  var _selectionDirectionHandler = function (options) {
    options = options || {};
    var bgt = window.batchGeoTableMap.batchGeoTable;
    var rs = bgt.RowSelect;
    var selectedRows = rs.getSelectedRows();

    // if there are no rows selected return out
    if (selectedRows.length <= 0) return;

    var displayData = bgt.getDisplayData();
    var nextRowIndex;

    // loop through displayData to find the next index to be selected
    for (var i = 0; i < displayData.length; i++) {
      if (
        options.direction === "up" &&
        selectedRows[0].id === displayData[i].id
      ) {
        nextRowIndex = i > 0 ? i - 1 : 0;
        break;
      } else if (
        options.direction === "down" &&
        selectedRows[selectedRows.length - 1].id === displayData[i].id
      ) {
        nextRowIndex = i + 1;
        break;
      }
    }

    var nextRowId = displayData[nextRowIndex].id;

    if (options.addRows) {
      // build array of current selection ids + newRowId
      var selectedIds = selectedRows.map(function (row) {
        return row.id;
      });
      // push or unshift nextRowId into current selection
      if (options.direction === "down") {
        selectedIds.push(nextRowId);
      } else {
        selectedIds.unshift(nextRowId);
      }
      // and finally select them
      BatchGeoStore.dispatch({
        type: "ROW_SELECT_SELECT",
        selectedRows: selectedIds,
      });
    } else {
      // if not adding to selection then scroll to the row and select it.
      bgt.scrollToRow(nextRowId, { position: "middle" });
      BatchGeoStore.dispatch({
        type: "ROW_SELECT_SELECT",
        selectedRows: [nextRowId],
      });
    }
  };

  var _shortcuts = [
    {
      key: 191, // Key: ?
      action: function () {
        BatchGeo.customDialog(
          '<div class="keyboard-shortcuts">' +
            '<div class="keyboard-shortcuts-left">' +
            "<p><strong>" +
            strings.get("MODAL_TITLE") +
            "</strong></p>" +
            "<table>" +
            "<tbody>" +
            "<tr><td><kbd>?</kbd></td> <td>" +
            strings.get("SHOW_MODAL_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>Esc</kbd></td> <td>" +
            strings.get("CLOSE_MARKER_SHORTCUT") +
            "</td></tr>" +
            "</tbody>" +
            "</table>" +
            "<p><strong>" +
            strings.get("CLOSE_MARKER_SHORTCUT") +
            "</strong></p>" +
            "<table>" +
            "<tbody>" +
            "<tr><td><kbd>1</kbd></td> <td>" +
            strings.get("MAP_RESET_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>2</kbd></td> <td>" +
            strings.get("USER_GEOLOCATION_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>3</kbd></td> <td>" +
            strings.get("HAND_TOOL_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>4</kbd></td> <td>" +
            strings.get("CYCLE_DRAWING_SHORTCUTS") +
            "</tr>" +
            "<tr><td><kbd>5</kbd></td> <td>" +
            strings.get("DISTANCE_RULER_SHORTCUT") +
            "</tr>" +
            "</tbody>" +
            "</table>" +
            "</div>" +
            '<div class="keyboard-shortcuts-right">' +
            "<p><strong>" +
            strings.get("MAP_SHORTCUTS_TITLE") +
            "</strong></p>" +
            "<table>" +
            "<tbody>" +
            "<tr><td><kbd>R</kbd></td> <td>" +
            strings.get("RESET_MAP_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>H</kbd></td> <td>" +
            strings.get("HEAT_VIEW_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>C</kbd></td> <td>" +
            strings.get("CLUSTER_VIEW_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>-</kbd> / <kbd>+</kbd></td> <td>" +
            strings.get("ZOOM_IN_OUT_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>[</kbd></td> <td>" +
            strings.get("ROADMAP_TERRAIN_SHORTCUT") +
            "</td></tr>" +
            "<tr><td><kbd>]</kbd></td> <td>" +
            strings.get("SATELLITE_HYBRID_SHORTCUT") +
            "</td></tr>" +
            '<tr><td><kbd>&uarr;</kbd> / <kbd>&darr;</kbd> / <span class="key-break"><kbd>&larr;</kbd> / <kbd>&rarr;</kbd></span></td><td>' +
            strings.get("PAN_MAP_SHORTCUT") +
            "</td></tr>" +
            "</tbody>" +
            "</table>" +
            "<p><strong>" +
            strings.get("DATA_TABLE_SHORTCUTS_TITLE") +
            "</strong></p>" +
            "<table>" +
            "<tbody>" +
            "<tr><td><kbd>&uarr;</kbd> / <kbd>&darr;</kbd></td> <td>" +
            strings.get("SELECT_ROWS_SHORTCUT") +
            "</td></tr>" +
            '<tr><td><kbd>shift</kbd> + <span class="key-break"><kbd>&uarr;</kbd> / <kbd>&darr;</kbd></span></td><td>' +
            strings.get("ADD_TO_SELECTION_SHORTCUT") +
            "</td></tr>" +
            "</tbody>" +
            "</table>" +
            "</div>" +
            "</div>",
          {
            heightOffset: "30%",
            width: "600px",
          },
        );
      },
    },
    {
      key: 27, // Key: Esc
      action: function () {
        // Esc will close the last marker info window if one is open. closeMarker()
        // takes care of the logic to do nothing if no marker is open.
        window.batchGeoGoogleMapsMarker.closeMarker();
      },
    },
    /**
     * BEGIN MAP SHORTCUTS
     */
    {
      key: 82, // Key: R
      context: "#mapWrap",
      modifier: function (e) {
        // don't refresh if someone is using ctrl/cmd + r to refresh page.
        return !e.ctrlKey && !e.metaKey;
      },
      action: function () {
        // R key will reset the map
        window.batchGeoMap.mapReset();
      },
    },
    {
      key: 219, // Key: [
      context: "#mapWrap",
      action: function () {
        // [ (left square bracket) will toggle between the two roadmap views.
        var map = window.batchGeoGoogleMapsManager.getMap();

        // custom themes replace the default roadmap view
        var isCustomMap =
          window.batchGeoGoogleMapsManager.settings.mapTypeIds.indexOf(
            "simpleMap",
          ) > -1;
        var availableTypes = [isCustomMap ? "simpleMap" : "roadmap", "terrain"];

        map.setMapTypeId(
          map.getMapTypeId() === availableTypes[0]
            ? availableTypes[1]
            : availableTypes[0],
        );
      },
    },
    {
      key: 221, // Key: ]
      context: "#mapWrap",
      action: function () {
        // [ (right square bracket) will toggle between the two satellite views.
        var map = window.batchGeoGoogleMapsManager.getMap();
        map.setMapTypeId(
          google.maps.MapTypeId[
            map.getMapTypeId() === "satellite" ? "HYBRID" : "SATELLITE"
          ],
        );
      },
    },
    {
      key: 49, // Key: 1
      context: "#mapWrap",
      action: function () {
        // number keys will correspond to the toolbar buttons
        // 1 resets the map
        window.batchGeoMap.mapReset();
      },
    },
    {
      key: 50, // Key: 2
      context: "#mapWrap",
      action: function () {
        // 2 toggles user location
        $(".batchgeo-toolbar-button.userLocation").trigger("click");
      },
    },
    {
      key: 51, // Key: 3
      context: "#mapWrap",
      action: function () {
        // 3 selects the hand tool
        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SET_MODE",
          mode: "hand",
        });
      },
    },
    {
      key: 52, // Key: 4
      context: "#mapWrap",
      action: function () {
        var keyModes = ["rectangle", "circle", "polygon"];
        var currentMode = BatchGeoStore.getState().DrawingManager.mode;
        var newMode = "";

        if (keyModes.indexOf(currentMode) < 0 && this.mode) {
          // if current mode is not part of this group
          // and there is a cached mode, use the cached mode
          newMode = this.mode;
        } else if (keyModes.indexOf(currentMode) === keyModes.length - 1) {
          // if current mode is last in this group then go back to rectangle
          newMode = "rectangle";
        } else {
          // else move to next mode
          newMode = keyModes[keyModes.indexOf(currentMode) + 1];
        }
        // cache new mode
        this.mode = newMode;
        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SET_MODE",
          mode: newMode,
        });
      },
    },
    {
      key: 53, // Key: 5
      context: "#mapWrap",
      action: function () {
        // 5 selects the ruler tool
        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SET_MODE",
          mode: "ruler",
        });
      },
    },
    {
      key: 72, // Key: H
      context: "#mapWrap",
      action: function () {
        // H toggles the heatmap view
        BatchGeoStore.dispatch({ type: "HEATMAP_TOGGLE" });
      },
    },
    {
      key: 67, // Key: C
      context: "#mapWrap",
      modifier: function (e) {
        // don't toggle cluster if someone is using ctrl/cmd + c to copy.
        return !e.ctrlKey && !e.metaKey;
      },
      action: function () {
        // C toggles the cluster view
        BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
      },
    },
    /**
     * BEGIN DATA TABLE SHORTCUTS
     */
    {
      key: 38, // Key: Up arrow
      context: "#dataView",
      modifier: function (e) {
        // don't run if trying to run multi-select command.
        return !e.shiftKey;
      },
      action: function () {
        // Up arrow with no modifiers moves the selected row up 1
        _selectionDirectionHandler({
          direction: "up",
          addRows: false,
        });
      },
    },
    {
      key: 40, // Key: Down arrow
      context: "#dataView",
      modifier: function (e) {
        // don't run if trying to run multi-select command.
        return !e.shiftKey;
      },
      action: function () {
        // Down arrow with no modifiers moves the selected row down 1
        _selectionDirectionHandler({
          direction: "down",
          addRows: false,
        });
      },
    },
    {
      key: 38, // Key: Up arrow
      context: "#dataView",
      modifier: function (e) {
        return e.shiftKey;
      },
      action: function () {
        // Up arrow with shift modifier adds 1 row up to the current selection
        _selectionDirectionHandler({
          direction: "up",
          addRows: true,
        });
      },
    },
    {
      key: 40, // Key: Down arrow
      context: "#dataView",
      modifier: function (e) {
        return e.shiftKey;
      },
      action: function () {
        // Up arrow with shift modifier adds 1 row down to the current selection
        _selectionDirectionHandler({
          direction: "down",
          addRows: true,
        });
      },
    },
  ];

  window.batchgeoKeyboardShortcuts = new window.KeyboardShortcuts(_shortcuts);
  window.batchgeoKeyboardShortcuts.enable();
};
